/* eslint-disable react/prop-types */
/* eslint-disable no-unused-vars */
import { useEffect, useState } from "react";

import "./Sidebar.css";
import { useContext } from "react";
import { Link, NavLink } from "react-router-dom";

import { SidebarContext } from "../../../context/SidebarContext";
import { navigationLinks } from "../../data/data";



const Sidebar = (props) => {

 
  const [activeLinkIdx] = useState(0);

  const [sidebarClass, setSidebarClass] = useState("");
  const { isSidebarOpen,toggleSidebar } = useContext(SidebarContext);

  const handleicon = (navigationLink) => {
    
      if (isSidebarOpen == false) {
   
        toggleSidebar();
      }
 
  };

  useEffect(() => {
    if (isSidebarOpen) {
      setSidebarClass("sidebar-change");
    } else {
      setSidebarClass("");
    }
  }, [isSidebarOpen]);

  return (
    <div className={`sidebar ${sidebarClass}`}>
      
        <nav className="navigation">
        <ul className="nav-list p-0">
          {navigationLinks.map((navigationLink) => {

            return (
              <li  className="nav-item " key={navigationLink.id}>
                <NavLink
                  to={navigationLink.path}
                  className={`nav-link ${
                    navigationLink.id === activeLinkIdx ? "active" : null
                  }    d-flex `}
                
                >
                  <img
                    src={navigationLink.image}
                    style={{width:'25px',marginLeft:"10px"}}
                
                    className={`nav-link-icon  ${
                      navigationLink.id === activeLinkIdx ? "active" : null
                    }    `}
                    alt={navigationLink.title}
                    onClick={() =>{ handleicon(navigationLink) }}
                  />
                   
                   <div className="icon-name" style={{fontSize:'20px',marginLeft:'8px',color:'white'}} >{navigationLink.title}</div>
                </NavLink>
              </li>
            );
          })}
        </ul>
     
   
      </nav>
   
    </div>
  );
};

export default Sidebar;
